import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { getQuestionComponentByKey } from "../../activityQuestions/components/questions/QuestionComponentMap";
import FollowupGridContainer from "./FollowupGridContainer";
import { customOrderQuestionsWithDependsOn } from "../../../utils/customQuestionsOrderWithDependsOn";
import { processQuestionVisibilityAndMandatory } from "../../activityQuestions/utils/mandatoryQuestions";

const FollowupActivityQuestions = ({ followUpUUID, gridContainer = FollowupGridContainer }) => {
    const questions = useSelector((state) => state.activityQuestions.questions);
    const isFetching = useSelector((state) => state.activityQuestions.isFetching);
    const isError = useSelector((state) => state.activityQuestions.isError);

    const followUpQuestions = questions[followUpUUID]?.mappedQuestions || [];
    const orderedQuestions = useMemo(() => customOrderQuestionsWithDependsOn(followUpQuestions), [followUpQuestions]);
    const processedQuestions = useMemo(() => {
        return orderedQuestions.map((question) => {
            const { dependencyCheck, isVisible, mandatoryCheck, isMandatory } = processQuestionVisibilityAndMandatory(question, orderedQuestions);

            return {
                question,
                dependencyCheck,
                mandatoryCheck,
                isVisible,
                isMandatory,
            };
        });
    }, [orderedQuestions]);
    if (isFetching || isError) return null;

    return (
        <Grid container spacing={1}>
            {processedQuestions
                .filter((processed) => processed.isVisible)
                .map(({ question, isMandatory }) =>
                    getQuestionComponentByKey(
                        question.questionType,
                        { question: { ...question, mandatory: isMandatory }, followUpUUID },
                        gridContainer,
                    ),
                )}
        </Grid>
    );
};

export default FollowupActivityQuestions;
